import React from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Image,
  Input,
  Stack,
  HStack,
  Text,
  Textarea,
  useToast,
  Center,
  Heading,
  Switch,
  Spacer,
  useColorMode,
  useDisclosure,
} from "@chakra-ui/react";
import LandingFooter from "@/src/components/LandingFooter";
import { useForm } from "react-hook-form";
import { validateEmail } from "@/src/utils/validate-functions";
import { pricing } from "@/services/contact";
import LandingHeader from "@/src/components/LandingHeader";
import LandingShell from "@/src/layouts/LandingShell";
import useTranslation from "next-translate/useTranslation";
import TopBackground from "@/src/components/TopBackground";
import { useState } from "react";
import { extendTheme } from "@chakra-ui/react";
import switchTheme from "@/src/components/chakra_ui/switch_theme";
// import PricingCard from "@/src/components/pricing_card/PricingCardFremium";
import PricingCardFremium from "@/src/components/pricing_card/PricingCardFremium";
import PricingCardPro from "@/src/components/pricing_card/PricingCardPro";
import PricingCard from "@/src/components/pricing_card/PricingCard";
import PricingCardModulable from "@/src/components/pricing_card/PricingCardModulable";
import { useAuth } from "@/src/contexts/AuthContext";
import LoginModal from "../components/LoginModal";
import { useRouter } from "next/router";
import { getFetcher,getFeedFetcher } from "../utils/fetcher";
import useSWR from "swr";
import { selectPlan } from "@/services/pricing";
import PricingContain from '@/src/components/PricingContain'
const PricingShell3 = () => {
  return (
    <LandingShell>
      <LandingHeader />
      <TopBackground />
      <PricingContain />
      <LandingFooter />
    </LandingShell>
  );
};


export default PricingShell3;
